import React, { Component } from 'react';
import { Link, browserHistory } from 'react-router';
import { connect } from 'react-redux';

import { setGuidePage } from '../../store/actions/SetGuidePage';

function mapStateToProps(state) {
   return {
    selectedPage: state.guide
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setGuidePage: (page) => {
      dispatch(setGuidePage(page))
      browserHistory.push('/guide-to-gardening/' + page); 
    }
  }
}

class GuideDropdown extends Component {

  selectGuidePage(e) {
    this.props.setGuidePage(e.target.value);
  }

  render() {
    return (
      <div className="GuideDropdown select-wrapper">
        <select onChange={this.selectGuidePage.bind(this)}>
          <option value="should-i-grow-marijuana">Should I Grow Marijuana?</option>
          <option value="part-one-introduction">Part I: Preparing Your Grow</option>
          <option value="space">Space</option>
          <option value="light">Light</option>
          <option value="water">Water</option>
          <option value="ph">PH</option>
          <option value="temperature">Temperature</option>
          <option value="humidity">Humidity</option>
          <option value="nutrients">Nutrients</option>
          <option value="ventilation">Ventilation</option>
          <option value="pest-control">Pest Control</option>
          <option value="acquiring-seeds">Acquiring Seeds</option>
          <option value="part-two-introduction">Part II: The Growing Process</option>
          <option value="germinating-seeds">Germinating Seeds</option>
          <option value="seedlings">Seedlings</option>
          <option value="vegetative-stage">Vegetative Stage</option>
          <option value="dertermining-gender">Determining gender</option>
          <option value="pruning">Pruning</option>
          <option value="flowering-stage">Flowering Stage</option>
          <option value="flushing">Flushing</option>
          <option value="harvesting">Harvesting</option>
          <option value="drying">Drying</option>
          <option value="curing">Curing</option>
          <option value="part-three-introduction">Part III: Taking It Further</option>
          <option value="cloning">Cloning</option>
          <option value="topping">Topping</option>
        </select>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(GuideDropdown);



// WEBPACK FOOTER //
// ./src/components/GuideDropdown/GuideDropdown.js